var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-dialog",
    {
      attrs: {
        title: _vm.title,
        "custom-class": "pd-view-doc-container",
        visible: _vm.show,
        width: "100%",
        cutline: false,
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _vm.show
        ? _c("yxtbiz-doc-viewer", {
            staticStyle: { height: "100%" },
            attrs: {
              "file-id": _vm.fileId,
              "file-info": _vm.fileInfo,
              "show-zoom": false,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }